/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
/* eslint-disable guard-for-in */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import AWS from 'aws-sdk';
import { FormattedMessage } from 'react-intl';
import { Card, CardBody, CardTitle, Table, Col, Row } from 'reactstrap';
import styles from './notams.module.scss';
import Separator from '../../../../components/separator';
import Spinner from '../../../../components/spinner';
import NotamTabFilters from './NotamTabFilters';
import { saveNotams } from '../redux/actions';

const Notams = ({ notamsList, actionSaveNotams, margin, handelFullScreen, fullScreenMode }) => {
  const [notams, setNotams] = useState([]);
  const [loading, setLoading] = useState(false);
  const urlParams = useParams();
  useEffect(() => {
    if (!notamsList.length) {
      setLoading(true);
      const source_ids = ['A', 'N'];
      const notamsList = [];
      for (const x in source_ids) {
        // gp.then(() => {
        const docClient = new AWS.DynamoDB.DocumentClient();
        const params = {
          TableName: `${process.env.REACT_APP_MAIN_PREFIX}notam`, // notam and weather shud come from main prefix
          Key: {
            // eslint-disable-next-line no-useless-concat
            notamKey: `${`${urlParams.airportCode.toUpperCase()}` + '_'}${source_ids[x]}`
          }
        };
        docClient.get(params).promise().then((data) => {
          actionSaveNotams(data?.Item?.records?.values);
          Object.values(data?.Item?.records).forEach((notam) => {
            notamsList.push(notam);
          });
          actionSaveNotams(notamsList);
          setNotams(notamsList);
          setLoading(false);
        }).catch((err) => {
          setLoading(false);
          console.log(err);
        });
      }
    }
  }, [urlParams.airportCode]);

  const handleSortData = (data) => {
    setLoading(true);
    let filteredNotams = [];
    if (data === 'ALL') {
      setNotams(notamsList);
      setLoading(false);
    } else {
      filteredNotams = notamsList.filter(notam => notam.notam_text.split(' ')[0] === data);
      setNotams(filteredNotams);
      setLoading(false);
    }
  };

  return (
    <Col lg={12} className={margin !== undefined ? `mt-0 ${styles.cardHeight}` : 'mt-4'}>
      <Card className={styles.Card} style={{ height: fullScreenMode?'100vh': '', width: fullScreenMode?'100vw': '' }}>
        <Spinner large active={loading} />
            <CardTitle className={styles.airfieldscardtitle}>
              <Col lg={12}>
                <Row>
                  <Col className={styles.notamText}>
                    <FormattedMessage
                      id="airfields.notams"
                      defaultText="NOTAMs"
                    />
                  </Col>
                  <Col>
                    <Row>
                      <Col>
                        <Row>
                          <Col lg={12}>
                            <NotamTabFilters
                              onClick={handleSortData}
                              fullScreenMode={fullScreenMode}
                              handelFullScreen={handelFullScreen}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </CardTitle>

        <hr className={styles.hrLine} />
        <CardBody className={styles.cardBody}>
          <Col lg={12} className={styles.notamscard}>
            <>
              <div className={styles.notams}>
                <div>
                  <Table borderless>
                    <Col className={styles.notamstableColumn}>
                      <thead className={styles.tableHead}>
                        <th className={`float-left ${styles.notamslabelId}`}>ID</th>
                        <Separator />
                        <th className={`float-left ${styles.notamslabels}`}>REPORT</th>
                      </thead>
                    </Col>
                    <tbody>
                      <tr>
                        <Col className={styles.notamstableColumn}>
                          {notams && notams.length
                            ? notams.map(n => (
                              <>
                                <tr className={styles.tableRowBottom}>
                                  <td className={styles.notamId}>{n.notam_id}</td>
                                  <Separator />
                                  <td className={styles.notamslabelstext}>{n.notam_text}</td>
                                  <div className={`${styles.cardborderline}`} />
                                </tr>
                              </>
                            ))
                            : ''}
                        </Col>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </>
          </Col>
        </CardBody>
      </Card>
    </Col>
  );
};


const mapStateToProps = state => ({
  notamsList: state.airfields.notams,
  profile: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionSaveNotams: (data) => {
    dispatch(saveNotams(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Notams);
